import { BASE_PATH } from 'config/common';

export default function(route: string): string {
  return `${BASE_PATH}${route}`;
}
